
export const SYNC_TYPE_SYNC_ALL = "syncAll";
export const SYNC_TYPE_SYNC_PROD_POS_M_COLL = "syncProdPosMColl";
export const SYNC_TYPE_SYNC_PRODUCT_REVIEWS = "syncProductReviews"